<template>
  <div class="k-marketplace-card">
    <div class="image">
      <img :src="product.img" class="product-image" alt="Imagem do produto">
    </div>
    <div class="content">
      <h2 class="title">
        {{product.title}}
      </h2>
      <div class="prices">
        <span class="price">
        {{`${product.symbol} ${product.value}`}}
      </span>
      <span class="old-price" v-if="product.old_value">
        {{`${product.symbol} ${product.old_value}`}}
      </span>
      </div>
      <span class="description" v-if="product.description">
        {{product.description}}
      </span>
    </div>
    <div class="tags" v-if="product.tags && product.tags.length > 0">
      <k-tag
      v-for="(tag, index) in product.tags"
      :key="`k-marketplace-card-tag-${index}`"
      :color="tag.color"
      class="tag"
      >
      {{tag.text}}
      </k-tag>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    KTag: () => import('./KTag.vue')
  },
  name: 'KMarketplaceCard',
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang='scss'>
@import "@/assets/scss/main.scss";;

.k-marketplace-card {
  cursor: pointer;
  width: 305px;
  font-family: $font-family;
  .image {
    width: 305px;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all ease 0.3s;
    &:hover {
      background: rgba(32,41,80,0.03);
    }
    .product-image {
      max-width: 160px;
      max-height: 200px;
      object-fit: contain;
    }
  }
  .content {
    padding: $spacing-xs $spacing-xs 0 $spacing-xs;
    text-align: left;
    .title {
      margin-top: 12px;
      margin-bottom: $spacing-xs;
      font-size: $size-4;
      font-weight: 400;
    }
    .prices {
      padding-bottom: $spacing-xs;
      .price {
        font-size: $size-4;
        font-weight: 600;
      }
      .old-price {
        font-size: $size-2;
        color: rgba($neutral-1, .4);
        text-decoration: line-through;
      }
    }
    .subtitle {
      color: $neutral-1;
      font-size: $size-3;
      font-weight: 400;
    }
  }
  .tags {
    display: flex;
    flex-wrap: wrap;
    padding: $spacing-xs;
    .tag + .tag {
      margin-left: $spacing-xs;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/KaledoComponents/KMarketplaceCard.vue